module.exports = __webpack_public_path__ + "img/clock-snooze.7872a2f4.svg";